import { render } from "./mvt-mapresults.vue?vue&type=template&id=56737fc6"
import script from "./mvt-mapresults.vue?vue&type=script&lang=js"
export * from "./mvt-mapresults.vue?vue&type=script&lang=js"

import "./mvt-mapresults.vue?vue&type=style&index=0&id=56737fc6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__